<template>
  <div class="iframe-container">
    <div v-if="loading" class="loading">
      <div class="loading-spinner"></div>
      <p>正在加载历史记录...</p>
    </div>
    <div class="iframe-wrapper" :class="{ 'loaded': !loading }">
      <iframe
        :src="iframeUrl"
        frameborder="0"
        width="100%"
        height="100%"
        allowfullscreen
        @load="onIframeLoad"
        ref="iframe"
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GptTranslateHistoryIframe',
  data() {
    return {
      iframeUrl: '',
      loading: true
    }
  },
  created() {
    // 从路由参数中获取URL，默认为历史页面
    this.iframeUrl = this.$route.query.url || 'https://agent.languagey.cn/docAgent/history';
  },
  mounted() {
    // 监听窗口大小变化，确保iframe自适应
    window.addEventListener('resize', this.handleResize);
    // 延迟设置iframe高度，确保页面完全加载
    setTimeout(() => {
      this.handleResize();
    }, 100);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    onIframeLoad() {
      this.loading = false;
      const iframe = this.$refs.iframe;
      if (iframe) {
        // 等待iframe内容完全加载后再设置高度
        setTimeout(() => {
          this.setIframeHeight();
        }, 500);
      }
    },
    setIframeHeight() {
      const iframe = this.$refs.iframe;
      if (iframe) {
        try {
          // 尝试获取iframe内容的实际高度
          const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
          if (iframeDoc && iframeDoc.body) {
            const contentHeight = Math.max(
              iframeDoc.body.scrollHeight,
              iframeDoc.body.offsetHeight,
              iframeDoc.documentElement.clientHeight,
              iframeDoc.documentElement.scrollHeight,
              iframeDoc.documentElement.offsetHeight
            );
            iframe.style.height = contentHeight + 'px';
          }
        } catch (e) {
          // 跨域情况下无法访问iframe内容，使用视口高度
          iframe.style.height = window.innerHeight + 'px';
        }
      }
    },
    handleResize() {
      // iframe自适应处理
      this.setIframeHeight();
    }
  }
}
</script>

<style lang="scss" scoped>
.iframe-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
  background-color: #f5f5f5;
}

.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 10;
  
  .loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #1AC49C;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto 15px;
  }
  
  p {
    color: #666;
    font-size: 14px;
    margin: 0;
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.iframe-wrapper {
  width: 100%;
  min-height: 100vh;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  overflow: hidden;
  
  &.loaded {
    opacity: 1;
  }
}

iframe {
  width: 100%;
  min-height: 100vh;
  border: none;
  display: block;
  overflow: hidden;
  background: transparent;
}
</style>